import { ButtonActionType } from '@vedalib/editor/lib/elements'

import Padding from 'components/Editor/Toolbar/Padding'
import { chainName, FormField } from 'components/formKit'
import { Typography } from 'components/uiKit/Typography'
import { t } from 'services/Translation'

import {
  ACTION,
  ACTION_TYPE,
  BLOCK_NAVIGATION,
  CONDITION,
  FILE,
  FOURTH_LABEL,
  LABEL,
  POSITION,
  SECOND_LABEL,
  SECTION_NAVIGATION,
  SHOW_BLOCK,
  TARGET,
  THIRD_LABEL,
  URL,
} from './buttonConfig'
import type { ButtonFormValueType } from './buttonTypes'

const VARIANTS_CONFIGS = [
  { key: 'correct', title: t('input.label.correct') },
  { key: 'incorrect', title: t('input.label.incorrect') },
] as const

const ButtonFormValue: ButtonFormValueType = ({ name, element }) => (
  <Padding bottom gap sides>
    <FormField config={chainName(name, ACTION_TYPE)} />
    <FormField config={chainName(name, ACTION)} />
    <FormField config={chainName(name, SECTION_NAVIGATION)} />
    <FormField config={chainName(name, BLOCK_NAVIGATION)} />
    <FormField config={chainName(name, URL)} />
    <FormField config={chainName(name, FILE)} />
    <FormField config={chainName(name, LABEL)} />
    <FormField config={chainName(name, TARGET)} />
    <FormField config={chainName(name, POSITION)} />
    <FormField config={chainName(name, CONDITION)} />
    <FormField config={chainName(name, SHOW_BLOCK)} />
    <FormField config={chainName(name, SECOND_LABEL)} />
    <FormField config={chainName(name, THIRD_LABEL)} />
    <FormField config={chainName(name, FOURTH_LABEL)} />
    {element?.value?.actionType === ButtonActionType.decision &&
      VARIANTS_CONFIGS.map(({ key, title }) => (
        <>
          <Typography size={13} styleType='heading' weight='medium'>
            {title}
          </Typography>
          <FormField config={chainName(`${name}.${key}`, ACTION_TYPE)} />
          <FormField config={chainName(`${name}.${key}`, ACTION)} />
          <FormField config={chainName(`${name}.${key}`, SECTION_NAVIGATION)} />
          <FormField config={chainName(`${name}.${key}`, BLOCK_NAVIGATION)} />
          <FormField config={chainName(`${name}.${key}`, URL)} />
          <FormField config={chainName(`${name}.${key}`, FILE)} />
          <FormField config={chainName(`${name}.${key}`, LABEL)} />
          <FormField config={chainName(`${name}.${key}`, TARGET)} />
          <FormField config={chainName(`${name}.${key}`, POSITION)} />
          <FormField config={chainName(`${name}.${key}`, CONDITION)} />
          <FormField config={chainName(`${name}.${key}`, SHOW_BLOCK)} />
          <FormField config={chainName(`${name}.${key}`, SECOND_LABEL)} />
          <FormField config={chainName(`${name}.${key}`, THIRD_LABEL)} />
          <FormField config={chainName(`${name}.${key}`, FOURTH_LABEL)} />
        </>
      ))}
  </Padding>
)

export default ButtonFormValue
